<template>
    <div class="w-full lg:w-72 flex-shrink-0 hidden lg:block lg:sticky lg:top-6 lg:bottom-6">
        <section>
            <p class="flex justify-between font-medium text-gray-900 cursor-pointer">
                {{ $t("r_legal.list_of_content") }}
            </p>
            <ul class="mt-2">
                <li
                    v-for="(section, index) in sections.filter((x) => x.points)"
                    :key="index"
                    class="loc"
                    :style="{
                        color: `${footer.mainColor}`,
                        color: `${footer.mainColor}19`,
                    }"
                >
                    <p
                        v-if="section.shortTitle"
                        class="cursor-pointer block px-3 py-2 text-black"
                        @click="goTo(index)"
                    >
                        {{ section.shortTitle }}
                    </p>
                </li>
            </ul>
        </section>
    </div>
</template>

<script>
export default {
    name: "DocumentList",
    props: {
        footer: Object,
        sections: Array,
    },
    emits: ["updateIframeHeight"],
    methods: {
        goTo(index) {
            const secName = "sec" + index;
            const targetSection = document.getElementById(secName);
            if (targetSection) {
                targetSection.scrollIntoView({ behavior: "smooth" });
            }
        },
    },
};
</script>

<style scoped>
.loc:hover {
    background-color: currentColor;
}
</style>
